import { Card, Typography } from 'antd';
import React from 'react';
import styles from './index.module.css';

import { useEffect, useRef, useState } from 'react';

import { getLoanData } from '../../../Utils/creditBureau';

const { Title, Text } = Typography;
type Direction = 'left' | 'right';

interface LoanCardProps {
  accountNumber: string;
  loanType: string;
  dateCreated: string;
  balance: number;
  cardWidth: string;
  cardType: string;
  cardBg: string;
}


const LoanCard: React.FC<LoanCardProps> = ({
  accountNumber,
  loanType,
  dateCreated,
  balance,
  cardWidth,
  cardType,
  cardBg,
}) => {
  return (
    <Card
      style={{
        border: '1px solid #f0f0f0',
        borderRadius: '8px',
        padding: '16px 16px 60px 16px',
        backgroundImage: `url('./${cardBg ? cardBg : 'loanCard'}.png')`,
      }}
      className={styles.liabilityCard}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '8px',
        }}
      >
        {cardType == 'loan' ? (
          <Typography.Text style={{ color: '#fff' }}>
            Loan acc no
          </Typography.Text>
        ) : (
          <Typography.Text style={{ color: '#fff' }}>
            Credit card no
          </Typography.Text>
        )}

        <Typography.Text strong style={{ color: '#fff' }}>
          ***{accountNumber.slice(-4)}
        </Typography.Text>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <Typography.Title level={4} style={{ color: '#fff' }}>
          {loanType}
        </Typography.Title>
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: '16px',
          left: '16px',
          textAlign: 'left',
          paddingLeft: '8px',
        }}
      >
        <Typography.Text style={{ color: '#fff' }}>
          Date Created:
        </Typography.Text>
        <br />
        <Typography.Text strong style={{ color: '#fff' }}>
          {dateCreated}
        </Typography.Text>
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: '16px',
          right: '16px',
          textAlign: 'right',
        }}
      >
        <Typography.Text strong style={{ color: '#fff' }}>
          {balance}
        </Typography.Text>
        <br />
        {cardType == 'loan' ? (
          <Typography.Text style={{ color: '#fff' }}>Balance</Typography.Text>
        ) : (
          <Typography.Text style={{ color: '#fff' }}>
            Avl. Limit
          </Typography.Text>
        )}
      </div>
    </Card>
  );
};

const LiabilityCardList: React.FC = () => {
  const carouselRef = useRef<any>(null);
  const [loanData, setLoanData] = useState(getLoanData())

  const handleViewAll = (direction: Direction) => {
    if (carouselRef.current) {
      if (direction === 'left') {
        (carouselRef.current as any).prev(); // Casting to any
      } else if (direction === 'right') {
        (carouselRef.current as any).next(); // Casting to any
      }
    }
  };

  const updateCardWidth = () => {
    const width = window.innerWidth;
    if (width >= 450 && width <= 750) {
      setCardWidth('50%');
    } else {
      setCardWidth('95%');
    }
  };

  const [cardWidth, setCardWidth] = useState(
    window.innerWidth >= 450 && window.innerWidth <= 750 ? '50%' : '95%'
  );

  useEffect(() => {
    window.addEventListener('resize', updateCardWidth);
    return () => window.removeEventListener('resize', updateCardWidth);
  }, []);

  return (
    <div style={{ paddingTop: '20px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Title style={{ paddingLeft: '10px' }} level={5}>
          Your Loans and Credit Cards
        </Title>
        {/* <Button onClick={() => handleViewAll('right')}>View All</Button> */}
      </div>
      <div className={styles.carousal_item}>
        {loanData.map(
          (loan: {
            accountNumber: string;
            loanType: string;
            dateCreated: string;
            cardType: string;
            balance: number;
            backGround: string;
          }) => (
            <LoanCard
              accountNumber={loan.accountNumber}
              loanType={loan.loanType}
              dateCreated={loan.dateCreated}
              balance={loan.balance}
              cardWidth={cardWidth}
              cardType={loan.cardType}
              cardBg={loan.backGround}
            />
          )
        )}
      </div>
    </div>
  );
};

export default LiabilityCardList;
